import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function Cashier_Dashboard() {
  return (
    <Dashboard sidebarType="Cashier">
      <DashboardConfig />
    </Dashboard>
  );
}
